var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('div',{staticClass:"review-stars"},_vm._l((_vm.isActive),function(val,idx){return _c('i',{key:idx,class:val ? 'fas fa-star active' : 'far fa-star',on:{"mouseover":function($event){return _vm.mouseOver(idx)}}})}),0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"review-direction"},[_vm._v("고객님의 리뷰가 만족스러우셨나요?"),_c('br'),_vm._v("만족도를 5점 만점으로 평가해주세요.")])
}]

export { render, staticRenderFns }